module.exports = __webpack_public_path__ + "static/img/start1.08f0aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/start1.png
// module id = 0X9t
// module chunks = 1